<!-- DownloadButton.vue -->
<template>
  <button 
    class="download-button" 
    :class="{ 'white': variant === 'white' }"
    @click="handleClick"
    :disabled="disabled"
  >
    {{ label }}
  </button>
</template>

<script>
export default {
  name: 'CustomButton',
  props: {
    label: {
      type: String,
      required: true,
      default: 'Télécharger l\'App'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: 'primary' // 'primary' | 'white'
    }
  },
  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
}
</script>

<style scoped>
.download-button {
  background: #F3C17D;
  color: #1a1a1a;
  font-size: 14px;
  font-weight: 600;
  padding: 8px 20px;
  border: 2px solid #2a2a2a;
  border-radius: 30px;
  cursor: pointer;
  text-decoration: none;
  display: inline-block;
  position: relative;
  transition: all 0.3s ease;
  box-shadow: 
    4px 4px 0px rgba(0, 0, 0, 0.15),
    5px 5px 10px rgba(0, 0, 0, 0.25);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif;
  white-space: nowrap;
  min-width: fit-content;
}

.download-button.white {
  background: #FFFFFF;
  color: #1a1a1a;
}

.download-button:hover:not(:disabled) {
  transform: translate(1px, 1px);
  box-shadow: 
    3px 3px 0px rgba(0, 0, 0, 0.15),
    4px 4px 8px rgba(0, 0, 0, 0.25);
}

.download-button:active:not(:disabled) {
  transform: translate(2px, 2px);
  box-shadow: 
    2px 2px 0px rgba(0, 0, 0, 0.15),
    3px 3px 6px rgba(0, 0, 0, 0.25);
}

.download-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>